import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
var Modal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, title = _a.title, children = _a.children, _b = _a.maxWidth, maxWidth = _b === void 0 ? "800px" : _b, headerActions = _a.headerActions;
    var _c = useState(false), isClosing = _c[0], setIsClosing = _c[1];
    var _d = useState(isOpen), shouldRender = _d[0], setShouldRender = _d[1];
    var modalRef = useRef(null);
    var previousActiveElementRef = useRef(null);
    // Handle open/close state changes
    useEffect(function () {
        if (isOpen) {
            setShouldRender(true);
            setIsClosing(false);
            // Store the currently focused element
            previousActiveElementRef.current = document.activeElement;
        }
        else if (shouldRender) {
            // Start closing animation
            setIsClosing(true);
            // Remove from DOM after animation completes
            var timer_1 = setTimeout(function () {
                setShouldRender(false);
                setIsClosing(false);
                // Restore focus to previously focused element
                if (previousActiveElementRef.current) {
                    previousActiveElementRef.current.focus();
                }
            }, 200); // Slightly longer to ensure smooth completion
            return function () { return clearTimeout(timer_1); };
        }
    }, [isOpen, shouldRender]);
    // 1. Keyboard Support - ESC key closes modal
    useEffect(function () {
        var handleKeydown = function (e) {
            if (e.key === "Escape") {
                onClose();
            }
        };
        if (isOpen) {
            document.addEventListener("keydown", handleKeydown);
            return function () { return document.removeEventListener("keydown", handleKeydown); };
        }
    }, [isOpen, onClose]);
    // 2. Body Scroll Lock - Prevent background scrolling when modal is open
    useEffect(function () {
        if (isOpen) {
            // Store original overflow value
            var originalOverflow_1 = document.body.style.overflow;
            document.body.style.overflow = "hidden";
            return function () {
                // Restore original overflow value
                document.body.style.overflow = originalOverflow_1;
            };
        }
    }, [isOpen]);
    // 3. Focus Management - Focus first focusable element and handle tab navigation
    useEffect(function () {
        if (isOpen && modalRef.current) {
            // Focus first focusable element in modal
            var focusableElements = modalRef.current.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            var firstElement_1 = focusableElements[0];
            if (firstElement_1) {
                // Small delay to ensure modal is fully rendered
                var timer_2 = setTimeout(function () {
                    firstElement_1.focus();
                }, 100);
                return function () { return clearTimeout(timer_2); };
            }
        }
    }, [isOpen]);
    var handleClose = function () {
        // Immediately trigger close without delay
        onClose();
    };
    if (!shouldRender)
        return null;
    return createPortal(React.createElement("div", { className: "lib-modal-overlay ".concat(isClosing ? "lib-modal-closing" : ""), onClick: handleClose },
        React.createElement("div", { ref: modalRef, className: "lib-modal-content", style: { maxWidth: maxWidth }, onClick: function (e) { return e.stopPropagation(); } },
            React.createElement("div", { className: "lib-modal-header" },
                React.createElement("h2", null, title),
                React.createElement("div", { className: "lib-modal-header-actions" },
                    headerActions,
                    React.createElement("button", { onClick: handleClose, className: "lib-modal-close" }, "\u00D7"))),
            React.createElement("div", { className: "lib-modal-body" }, children))), document.body);
};
export default Modal;
